/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkPaymentResolutionDto
 */
export interface LinkPaymentResolutionDto {
    /**
     * 
     * @type {string}
     * @memberof LinkPaymentResolutionDto
     */
    debtId?: string | null;
}

export function LinkPaymentResolutionDtoFromJSON(json: any): LinkPaymentResolutionDto {
    return LinkPaymentResolutionDtoFromJSONTyped(json, false);
}

export function LinkPaymentResolutionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkPaymentResolutionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'debtId': !exists(json, 'debtId') ? undefined : json['debtId'],
    };
}

export function LinkPaymentResolutionDtoToJSON(value?: LinkPaymentResolutionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'debtId': value.debtId,
    };
}

